import { getStreakColor } from '../lib/utils';

export default function StreakBadge({ streak = 0, size = 'md', showLabel = true }) {
  const color = getStreakColor(streak);
  const sizes = {
    sm: { container: 'px-2 py-1 gap-1 text-xs', flame: 'text-sm' },
    md: { container: 'px-3 py-1.5 gap-1.5 text-sm', flame: 'text-base' },
    lg: { container: 'px-4 py-2 gap-2 text-base', flame: 'text-xl' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      className={`inline-flex items-center ${s.container} rounded-full font-semibold`}
      style={{
        background: `${color}18`,
        border: `1px solid ${color}40`,
        color,
      }}
    >
      <span
        className={`${s.flame} ${streak > 0 ? 'animate-flicker' : ''}`}
        style={{ animationDelay: `${Math.random() * 0.5}s` }}
      >
        🔥
      </span>
      {showLabel && <span>{streak} day{streak !== 1 ? 's' : ''}</span>}
    </div>
  );
}
